<h1 class="text-xl md:text-2xl font-semibold text-color m-0 mb-3 md:mb-4">{{ pageTitle() }}</h1>

@if (loadError()) {
  <p class="mb-3 text-red-500">No se pudieron cargar los datos de la persona.</p>
}

@if (loadingPerson()) {
  <app-skeleton-block variant="form" [rows]="5" />
} @else {
  <p-card styleClass="w-full">
    @if (isMobile()) {
      <p-stepper
        class="w-full agregar-persona__stepper--vertical"
        [value]="activeStep()"
        (valueChange)="onStepChange($event)"
      >
        @for (step of steps(); track step.value) {
          <p-step-item [value]="step.value">
            <p-step>{{ step.label }}</p-step>
            <p-step-panel>
              <ng-template #content let-activateCallback="activateCallback">
                @switch (step.value) {
                  @case (1) {
                    <app-agregar-persona-paso-datos-basicos
                      [initial]="initialDatosBasicos()"
                      (next)="onDatosBasicosNext($event); activateCallback(stepAfter(1))"
                    />
                  }
                  @case (2) {
                    <app-agregar-persona-paso-informacion-adicional
                      [initial]="initialAntecedentes()"
                      (back)="activateCallback(stepBefore(2))"
                      (antecedentes)="onAntecedentesChange($event)"
                      (next)="onAntecedentesNext($event); activateCallback(stepAfter(2))"
                    />
                  }
                  @case (3) {
                    <app-agregar-persona-paso-confirmacion
                      [datosBasicos]="datosBasicos()"
                      [initial]="initialConfirmacion()"
                      [saving]="saving()"
                      (back)="activateCallback(stepBefore(3))"
                      (save)="onSave($event)"
                    />
                  }
                }
              </ng-template>
            </p-step-panel>
          </p-step-item>
        }
      </p-stepper>
    } @else {
      <p-stepper
        class="w-full agregar-persona__stepper--horizontal"
        [value]="activeStep()"
        (valueChange)="onStepChange($event)"
      >
        <p-step-list>
          @for (step of steps(); track step.value) {
            <p-step [value]="step.value">{{ step.label }}</p-step>
          }
        </p-step-list>

        <p-step-panels>
          @for (step of steps(); track step.value) {
            <p-step-panel [value]="step.value">
              <ng-template #content let-activateCallback="activateCallback">
                @switch (step.value) {
                  @case (1) {
                    <app-agregar-persona-paso-datos-basicos
                      [initial]="initialDatosBasicos()"
                      (next)="onDatosBasicosNext($event); activateCallback(stepAfter(1))"
                    />
                  }
                  @case (2) {
                    <app-agregar-persona-paso-informacion-adicional
                      [initial]="initialAntecedentes()"
                      (back)="activateCallback(stepBefore(2))"
                      (antecedentes)="onAntecedentesChange($event)"
                      (next)="onAntecedentesNext($event); activateCallback(stepAfter(2))"
                    />
                  }
                  @case (3) {
                    <app-agregar-persona-paso-confirmacion
                      [datosBasicos]="datosBasicos()"
                      [initial]="initialConfirmacion()"
                      [saving]="saving()"
                      (back)="activateCallback(stepBefore(3))"
                      (save)="onSave($event)"
                    />
                  }
                }
              </ng-template>
            </p-step-panel>
          }
        </p-step-panels>
      </p-stepper>
    }
  </p-card>
}